import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import type { DialogPortalContainer } from '~/client/src/shared/components/shadcn-ui/dialog'
import WarningNote from '~/client/src/shared/components/WarningNote/WarningNote'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import SitePermitCreationFormStore from '../WorkflowCreationForm.store'

interface IProps {
  store: SitePermitCreationFormStore
  portalContainer?: DialogPortalContainer
}

const HoursOfOperationDialog: React.FC<IProps> = ({
  store,
  portalContainer,
}) => {
  const {
    hoursWarningDialogAction,
    hoursWarningNotes,
    projectHoursNote,
    confirmHoursWarnings,
    cancelHoursWarnings,
  } = store

  const isApproval = hoursWarningDialogAction === 'approve'
  const notes = hoursWarningDialogAction
    ? [projectHoursNote, ...hoursWarningNotes].filter(Boolean)
    : []

  return (
    <ConfirmDialog
      isOpen={!!hoursWarningDialogAction}
      title={Localization.translator.outsideWorkingHours}
      onCancelClicked={cancelHoursWarnings}
      onDoneClicked={confirmHoursWarnings}
      cancelTitle={Localization.translator.goBack}
      doneTitle={
        isApproval
          ? Localization.translator.approveAnyway
          : Localization.translator.submitAnyway
      }
      portalContainer={portalContainer}
    >
      <div className="tw:flex tw:flex-col tw:gap-3">
        {notes.map((note, index) => (
          <WarningNote key={index} note={note} isTitleShown isEveryLineShown />
        ))}
        <span className="tw:text-app-meta tw:text-muted-foreground">
          {isApproval
            ? Localization.translator.youCanStillApprove
            : Localization.translator.youCanStillSubmit}
        </span>
      </div>
    </ConfirmDialog>
  )
}

export default observer(HoursOfOperationDialog)
